import { httpsCallable } from "firebase/functions";
import { functions } from '../firebase';

/**
 * Log an error to Cloud Logging via the logClientError Cloud Function.
 * Also preserves the local browser console.error.
 * 
 * NEVER pass sensitive data (email, phone) in context.
 * Safe fields: guestCode, guestName, step, rsvpStatus.
 */
export const logError = async (action, error, context = {}) => {
    // Always keep the local console log
    console.error(action, error);

    try {
        const logClientError = httpsCallable(functions, 'logClientError');
        await logClientError({
            action,
            error: error?.message || String(error),
            errorCode: error?.code || null,
            context
        });
    } catch {
        // Silently fail — logging must never break the app
    }
};
